import { render, staticRenderFns } from "./ListShukaArea.vue?vue&type=template&id=79c67e36&"
import script from "./ListShukaArea.vue?vue&type=script&lang=ts&"
export * from "./ListShukaArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports